// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__4bWk4","col":"styles_col__DXJLG"};